export default __webpack_public_path__ + "static/media/europe.a6051740.jpg";